import { Grid2 } from "@mui/material";
import React from "react";
import AnalyticsBox from "../Common/AnalyticsBox";

const AnalyticsComponent = ({ setCalenderComponentState, isSelf, data }) => {
  return (
    <Grid2 container spacing={2} sx={{ mt: 4 }}>
      <AnalyticsBox title="Post" number={data ? data.posts : "0"} />

      <AnalyticsBox
        title="Subscribers"
        number={data ? data.subscribers : "0"}
      />

      <AnalyticsBox title="followers" number={data ? data.followers : "0"} />

      <AnalyticsBox
        title="Calendar"
        schedule
        setCalenderComponentState={setCalenderComponentState}
        isSelf
      />

      {/* <AnalyticsBox title="Views" number="543.4K" per="/mo" bottomText />
      <AnalyticsBox
        title="Engagement Rates"
        number="333.4K"
        per="/mo"
        bottomText
      />
      <AnalyticsBox
        title="revenue streams"
        number="15.4K"
        per="/mo"
        bottomText
        dollar
      />
      <AnalyticsBox
        title="total earnings"
        number="34.4K"
        per="/video subscription"
        bottomText
        dollar
      /> */}
    </Grid2>
  );
};

export default AnalyticsComponent;
